export default __webpack_public_path__ + "static/media/trend_down.5286f9ca.svg";